module.exports = __webpack_public_path__ + "static/img/news5.b52af89.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/news5.jpg
// module id = IobX
// module chunks = 1